/* eslint-disable react/jsx-no-literals */
import { cn } from '@/lib/utils'

export const col = (
  top: any,
  bottom: any,
  className?: string,
  topClassName?: string,
  bottomClassName?: string,
) => (
  <div className={cn('flex flex-col justify-between', className)}>
    <div
      className={cn('text-xs text-muted-foreground sm:text-sm', topClassName)}
    >
      {top}
    </div>
    <div className={cn('text-sm font-semibold sm:text-base', bottomClassName)}>
      {bottom}
    </div>
  </div>
)

export const row = (left: any, right: any) => (
  <div className="grid grid-cols-2">
    <div className="text-sm text-muted-foreground text-left">{left}</div>
    <div className="break-all font-semibold text-right">{right}</div>
  </div>
)

export const color = (
  beforeSlash: any,
  afterSlash: any,
  colorConfig = {
    before: 'text-green-700',
    after: '',
  },
) => (
  <span>
    <span className={colorConfig.before}>{beforeSlash}</span> /{' '}
    <span className={colorConfig.after}>{afterSlash}</span>
  </span>
)

export const multiColor = (
  beforeSlash: any,
  afterSlash: any,
  afterSlash2: any,
  colorConfig = {
    before: 'text-green-700',
    after: '',
    after2: '',
  },
) => (
  <span>
    <span className={colorConfig.before}>{beforeSlash}</span> /{' '}
    <span className={colorConfig.after}>{afterSlash}</span> /{' '}
    <span className={colorConfig.after2}>{afterSlash2}</span>
  </span>
)
